import { render, staticRenderFns } from "./newExamDialog.vue?vue&type=template&id=35603a18"
import script from "./newExamDialog.vue?vue&type=script&lang=js"
export * from "./newExamDialog.vue?vue&type=script&lang=js"
import style0 from "./newExamDialog.vue?vue&type=style&index=0&id=35603a18&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports